import React, { Component } from 'react'
import View from './view'
import { passwordPolicyValidator } from '../utils/passwordPolicyValidator'

class PasswordPolicy extends Component {

  render() {
    const {
      errors,
      password
    } = this.props

    return (
      <View 
        passwordState={passwordPolicyValidator(password || '')}
        errors={errors}
      />
    )
  }
}

export default PasswordPolicy


// WEBPACK FOOTER //
// ./src/password-policy/index.js